<template>
  <!-- NOTE (TEMPLATE) show the universitys -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/organizations'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <b-button
        class="btn btn-success my-2"
        to="/admin/addOrganization"
        v-if="role == 'admin'"
        ><strong class="black--text"
          >افزودن انجمن دانشجویی جدید +</strong
        ></b-button
      >
      <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 0 1px 15px">
        <v-col>
          <h4 style="margin-top: 9px">انجمن‌های دانشجویی‌</h4>
        </v-col>
        <v-col>
          <v-btn
            class="bc-primary text-white btn-radius float-end"
            width="200"
            height="45"
            elevation="0"
            :disabled="isBusy || !items.length"
            @click="$refs.table1.$el.click()"
          >
            <span class="fs-small">
              خروجی اکسل

              <v-icon>$Excel</v-icon></span
            >
          </v-btn>
          <vue-excel-xlsx
            v-show="false"
            ref="table1"
            :data="items"
            :columns="excelFields"
            :filename="'لیست انجمن‌های دانشجویی'"
            :sheetname="currentDate"
          >
            دریافت اکسل
          </vue-excel-xlsx>
        </v-col>
      </v-row>
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-university) to show the university list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="انجمنی ثبت نشده است"
        empty-filtered-text="نتیجه‌ای برای نمایش یافت نشد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle">
            <!-- NOTE (<a>) to go to the universitys profile -->
            <v-btn
              color="primary"
              style="width: 120px"
              @click="
                (editModal = true),
                  getUniversities(),
                  (editOrganization = data.item)
              "
              >ویرایش</v-btn
            ><br />
            <!-- <div v-if="role == 'admin'" class="mt-2 mr-2">
              <div v-if="!data.item.busy">
                <b-button
                  class="text-light"
                  variant="danger"
                  @click="activeDeactive(data.item, 'deactive')"
                  v-if="data.item.status == 'active'"
                  >غیرفعال کردن</b-button
                >
                <b-button
                  class="text-light"
                  variant="info"
                  @click="activeDeactive(data.item, 'active')"
                  v-else
                  >فعال کردن</b-button
                >
              </div>
              <div class="text-center" v-else>
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
            </div> -->
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
      <span v-show="false">{{ reactivity }}</span>
    </b-card>
    <router-view></router-view>
    <v-dialog v-model="editModal" width="800">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">ویرایش انجمن دانشجویی</span>
            </v-col>
            <v-col class="text-left">
              <span @click="editModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" class="">
              <b-form-group
                label="نام انجمن دانشجویی"
                :class="editOrganization.name ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  v-model="editOrganization.name"
                  type="text"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="نام دبیر انجمن دانشجویی">
                <b-form-input
                  trim
                  v-model="editOrganization.headName"
                  :no-wheel="true"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group
            label="دانشگاه"
            :class="editOrganization.universityId ? 'done' : 'required'"
          >
            <v-autocomplete
              v-model="editOrganization.universityId"
              :items="universities"
              item-value="id"
              item-text="text"
              dense
              outlined
              class="dropdown-style"
              hide-details
            ></v-autocomplete>
          </b-form-group>
          <b-form-group label="وضعیت">
            <v-autocomplete
              v-model="editOrganization.status"
              :items="OrganizationStatus"
              item-value="id"
              item-text="text"
              dense
              outlined
              class="dropdown-style"
              hide-details
            ></v-autocomplete>
          </b-form-group>

          <b-button
            :disabled="
              !editOrganization.name ||
              !editOrganization.universityId ||
              !editOrganization.status
            "
            variant="success"
            :disable="isBusy"
            @click="editOrgan()"
            >ثبت تغییرات</b-button
          >
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import Organization from "./Organization.vue";
export default {
  components: {},
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "نام انجمن دانشجویی" },
        { key: "university", label: "نام دانشگاه" },
        { key: "headName", label: "نام دبیر" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "name", label: "نام انجمن دانشجویی" },
        { field: "university", label: "نام دانشگاه" },
        { field: "headName", label: "نام دبیر" },
      ],
      OrganizationStatus: [
        { id: "active", text: "فعال" },
        { id: "inactive", text: "غیرفعال" },
      ],
      items: [],
      filter: "",
      isBusy: false,
      role: window.localStorage.role,
      reactivity: false,
      editModal: false,
      universities: [],
      editOrganization: {},
    };
  },
  watch: {
    $route: function () {
      this.onMounted();
    },
  },
  methods: {
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/organizations/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.items = res.data;
            this.totalRows = this.items.length;
            this.items.forEach((x) => (x.busy = false));
            this.isBusy = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    activeDeactive(item, status) {
      let accelerator = item;
      accelerator.busy = true;
      this.reactivity = !this.reactivity;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/accelerator/" + status,
          {
            acceleratorId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          accelerator.busy = false;
          this.reactivity = !this.reactivity;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.onMounted();
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          accelerator.busy = false;
          this.reactivity = !this.reactivity;
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    hideModal(type) {
      // NOTE (modal) to hide modal
      this.$refs[type].hide();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showAddAccelerator() {
      this.newAccelerator = {};
      this.newAcceleratorDialog = true;
    },
    getUniversities() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    editOrgan() {
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/organization/edit",
          {
            organizationId: this.editOrganization.id,
            name: this.editOrganization.name,
            headName: this.editOrganization.headName,
            universityId: this.editOrganization.universityId,
            status: this.editOrganization.status,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast("انجمن دانشجویی با موفقیت ویرایش گردید.", "success");
          this.editModal = false;
          this.onMounted();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
          this.isBusy = false;
        });
    },
  },
  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.tdClass {
  min-width: 200px;
}

.table .thead-dark th {
  min-width: 4em;
}

.color {
  background-color: #0c4961;
  color: white;
}
.required {
  color: red;
}

.done {
  color: green;
}
</style>
